import { render } from "./RealTimeClockMascot.vue?vue&type=template&id=fd864b34&scoped=true"
import script from "./RealTimeClockMascot.vue?vue&type=script&lang=js"
export * from "./RealTimeClockMascot.vue?vue&type=script&lang=js"

import "./RealTimeClockMascot.vue?vue&type=style&index=0&id=fd864b34&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd864b34"]])

export default __exports__